import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { EventFilter, IEvent } from "src/app/core/models/event";

export const EventActions = createActionGroup({
    source: 'Event',
    events: {
        'Load Events': emptyProps(),
        'Load Events Success': props<{ events: IEvent[] }>(),
        'Load Events Failure': props<{ error: unknown }>(),
        'Load Fake Events': emptyProps(),
        'Load Fake Events Success': props<{ events: IEvent[] }>(),
        'Load Fake Events Failure': props<{ error: unknown }>(),
        'Update Event': props<{ event: IEvent }>(),
        'Update Event Success': props<{ event: IEvent }>(),
        'Update Event Failure': props<{ error: unknown }>(),
        'Set Filters': props<{ filters: EventFilter }>(),
        'Reset Filters': emptyProps(),
        'Select Event': props<{ id: string }>(),
    }
});